import styled from "@emotion/styled";
export const BannerLinkOverflow = styled("span")`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
//# sourceMappingURL=BannerLinkOverflow.js.map